import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { InformationModal } from 'app/components/Modal/InformationModal.jsx';
import { WIDGET_TYPES } from 'app/pages/Project/ProductionManagement/Dashboards/constants';
const ModalWidgetInformation = ({ widget }) => {
    const { defaultName, type, description } = widget;
    const getImageURL = (widgetType) => {
        switch (widgetType) {
            case WIDGET_TYPES.EPISODE_STATUS:
                return new URL('app/styles/images/episodeStatus.png', import.meta.url).href;
            case WIDGET_TYPES.EPISODE_COSTS:
                return new URL('app/styles/images/episodeCosts.png', import.meta.url).href;
            case WIDGET_TYPES.GLOBAL_STATUS:
                return new URL('app/styles/images/globalStatus.png', import.meta.url).href;
            case WIDGET_TYPES.GLOBAL_COSTS:
                return new URL('app/styles/images/globalCosts.png', import.meta.url).href;
            default:
                return '';
        }
    };
    return (_jsx(InformationModal, { hideValidate: true, disableBackdropClick: false, children: _jsxs("div", { children: [_jsxs("h3", { style: { fontSize: '24px' }, children: [defaultName, " widget"] }), _jsx("p", { style: { margin: '25px 0' }, children: description }), _jsx("img", { src: getImageURL(type), style: { height: 420, display: 'block', margin: '0 auto' } })] }) }));
};
export default ModalWidgetInformation;
